import React from 'react'
import './Tourplaces.css'
import Footer from '../Footer/Footer'

import MF1 from '../img/mehrangardh/meh.jpg'
import MF2 from '../img/mehrangardh/meh1.jpg'

import MD from '../img/Md/md.jpg'
import MD1 from '../img/Md/md1.jpg'

import UB from '../img/UB/ub.jpg'
import UB1 from '../img/UB/ub1.jpg'

import KL from '../img/kal/kl.jpg'
import KL1 from '../img/kal/kl1.jpg'

import JS from '../img/js/js.jpg'
import JS1 from '../img/js/js1.jpg'


import GG from '../img/GG/gg1.jpg'
import GG1 from '../img/GG/header.jpg'

const Tourplaces = () => {
  return (
    <>
      <div className="tourM">
        <span>JODHPUR TOURISM</span>
        <span>Top Destinations And Gateways To Visit In Jodhpur
        </span>

      </div>
      <div className="tourdet">
        <span >JODHPUR BEST DESTINATIONS</span>
        <div className="tourjodh">
          <span className='tagtitle'>1. MEHRANGARH FORT
          </span>
          <div className="images">
          <img src={MF1} alt="mehrangarh" />
<img src={MF2} alt="" />
<p>MEHRANGARH, ALSO KNOWN AS MEHRAN FORT WAS BUILT BY RAO JODHA IN 1459 IN JODHPUR, IS ONE OF THE LARGEST FORTS IN THE COUNTRY. IT IS SITUATED AT THE TOP OF A 410 FEET ELEVATED HILL AND GUARDED BY MASSIVE WALLS. ONE OF THE MOST EASILY RECOGNISABLE FORTS IN JODHPUR, IT HAS APPEARED IN MANY HOLLYWOOD AND BOLLYWOOD PRODUCTIONS SUCH AS THE LION KING, THE DARK KNIGHT RISES, AND THE MORE RECENT - THUGS OF HINDOSTAN. THE ENTRANCE OF THE FORT, ATOP A HILL, IS MAJESTIC AND HAS SEVEN GATES. THESE ARE CALLED VICTORY GATE, FATEH GATE, GOPAL GATE, BHAIRON GATE, DEDH KAMGRA GATE, MARTI GATE AND FINALLY LOHA GATE. EACH OF THESE WAS BUILT AT DIFFERENT TIMES AND SERVES A VERY SPECIFIC PURPOSE. THE FORT ALSO HAS ONE OF THE WELL-STOCKED MUSEUMS OF RAJASTHAN. THERE ARE SIX DIFFERENT GALLERIES IN THE MEHRANGARH MUSEUM: ELEPHANT'S HOWDAHS, PALANQUINS, DAULAT KHANA, ARMOURY, PAINTINGS AND THE TURBAN GALLERY. NATIONAL GEOLOGICAL MONUMENT, NAGNECHA MATAJI TEMPLE, CHAMUNDA TEMPLE AND RAO JODHA DESERT ROCK PARK ARE THE TOURIST ATTRACTIONS IN MEHRANGARH FORT.</p>
          </div>

          <span className='tagtitle'>2.JASWANT THADA
          </span>
          <div className="images">
          <img src={JS} alt="JASWANT THADA" />
<img src={JS1} alt="JASWANT THADA" />
<p>IN THE ROYAL STATE OF JODHPUR LIES JASWANT THADA, A SPLENDID MARBLE CENOTAPH MONUMENT THAT IS ALSO A MAUSOLEUM FOR THE KINGS OF MARWAR. THE MEMORIAL WAS BUILT IN THE HONOUR AND MEMORY OF MAHARAJA JASWANT SINGH II BY HIS SON MAHARAJA SARDAR SINGH IN 1899 AND IS STILL USED BY THE MARWAR ROYAL FAMILY AS CREMATION GROUNDS. THE BEAUTIFUL EDIFICE IS MADE OUT OF INTRICATELY CARVED MARBLE THAT IS OFFSET VIBRANTLY AGAINST THE RED STEPS THAT LEAD UP TO THE ENTRANCE. JASWANT THADA IN JODHPUR IS CONSIDERED AS AN ARCHITECTURAL LANDMARK AND MUST BE SEEN BY ONE AND ALL. ON THE STEPS LEADING UP TO THE MONUMENT, ONE CAN SEE LOCAL MUSICIANS AND FOLK DANCERS ENTERTAIN THE VISITORS.</p>
          </div>

          <span className='tagtitle'>3. UMAID BHAVAN
          </span>
          <div className="images">
          <img src={JS} alt="JASWANT THADA" />
<img src={JS1} alt="JASWANT THADA" />
<p>UMAID BHAVAN PALACE IN JODHPUR IS A WONDERFUL AMALGAMATION OF A FASCINATING PAST AND A LUXURIOUS PRESENT. IT IS, AT THE SAME TIME - A HERITAGE HOTEL, A MUSEUM AND THE RESIDENCE OF THE ROYAL FAMILY OF THE PRESENT OWNER, RAJA GAJ SINGH. IN ADDITION TO BEING OF A HISTORICAL LANDMARK, THE PALACE WAS COMMISSIONED IN 1929, WAS BUILT IN ORDER TO PROVIDE EMPLOYMENT TO THE DROUGHT AND GRIEF-STRICKEN FARMERS OF THE AREA AND THUS TOOK LONGER TO COMPLETE. UMAID BHAVAN PALACE OFFERS AMAZING ENCOUNTERS RANGING FROM HERITAGE WALKS TO UNFORGETTABLE DINING EXPERIENCES. THE AWARD-WINNING HOTEL IS WELL-KNOWN AND LOVED FOR ITS HOSPITALITY AND A FEEL OF THE LUXURIOUS LIVING. IT WAS RECENTLY IN THE NEWS FOR BEING THE SITE OF THE BOLLYWOOD SUPERSTAR PRIYANKA CHOPRA AND NICK JONAS - A RENOWNED POP STAR FROM THE BAND - ONE DIRECTION.</p>
          </div>
          <span className='tagtitle'>
          </span>
          <div className="images">
          <img src={UB} alt=" UMAID BHAVAN" />
<img src={UB1} alt=" UMAID BHAVAN" />
<p></p>
          </div>
          <span className='tagtitle'>4. MANDORE GARDEN
          </span>
          <div className="images">
          <img src={MD} alt="MANDORE GARDEN" />
<img src={MD1} alt="MANDORE GARDEN" />
<p>MANDORE GARDEN IS SITUATED IN MANDORE WHICH WAS ONCE THE RULING SEAT OF THE PRATIHARA DYNASTY. THE GARDEN IS A PART OF THE MORE MASSIVE MEHRANGARH FORT, AND ALSO HOUSES THE FAMOUS HALL OF HEROES AND THE TEMPLE OF THREE HUNDRED MILLION GODS. THE GARDEN ALSO HAS A GOVERNMENT MUSEUM, WHICH IS FULL OF ARTEFACTS AND OLD RELICS. THE MOST STRIKING FEATURE OF THE GARDEN IS THE GORGEOUS CENOTAPHS OR 'DEWALS' THAT CAN BE FOUND SPREAD ALL ACROSS THE MANDORE GARDENS. UNDOUBTEDLY, THE MOST BEAUTIFUL AND FAMOUS OF THESE CENOTAPHS IS THE ONE THAT BELONGS TO MAHARAJA AJIT SINGH.</p>
          </div>

          <span className='tagtitle'>5. KAYLANA LAKE  </span>

          <div className="images">
          <img src={KL} alt=" KAYLANA LAKE" />
<img src={KL1} alt="JASWANT THADA" />
<p>THE KAYLANA LAKE IS A MASSIVE MANMADE LAKE, COVERING A SURFACE OF 84 SQUARE KM. CONSTRUCTED IN 1872 BY PRATAP SINGH, IT SERVES AS THE PRIMARY RESOURCE FOR DRINKING WATER FOR THE CITIZENS OF JODHPUR AND OTHER NEIGHBOURING SETTLEMENTS. A PEACEFUL LOCATION, THIS LAKE IS A MUST VISIT FOR MOST TRAVELLERS WHO ARE ROAD TRIPPING BETWEEN JAISALMER AND JODHPUR. IT ALSO SERVES AS AN EXCELLENT VIEWPOINT FOR SUNSETS IN JODHPUR.
</p>
          </div>
          <span className='tagtitle'>6. GHANTA GHER</span>

          <div className="images">
          <img src={GG} alt="GHANTA GHER" />
<img src={GG1} alt="JASWANT THADA" />
<p>THE GHANTA GHAR IN JODHPUR IS A MAGNIFICENT CLOCK TOWER IN THE CENTRE OF THE CITY, BUILT BY MAHARAJA SARDAR SINGH ABOUT 200 YEARS AGO. KNOWN AS THE CLOCK TOWER OF RAJASTHAN, IT IS A POPULAR LANDMARK THAT SIGNIFIES THE START OF OLD JODHPUR. THE TOWER OFFERS A BRILLIANT PANORAMIC VIEW OF THE CITY FROM THE TOP. THE AREA SURROUNDING THIS IMPOSING STRUCTURE IS BUSTLING WITH LOCALS PRESENTING ALL SORTS OF PRODUCTS AND SERVICES, MAKING IT THE BUSIEST AND LARGEST MARKETPLACE OF JODHPUR. THE MARKETS AND THE TOWER ARE A MUST VISIT FOR TRAVELLERS WHO WANT TO WITNESS AND EXPERIENCE THE CULTURE AND PEOPLE OF JODHPUR.</p>
          </div>

        </div>



      </div>
<Footer/>

    </>
  )
}

export default Tourplaces